// Disable TypeScript checking for this file until all of the imports are valid TS as well
// This will allow us to slowly migrate to TS without forcing us to address all type errors immediately
// @ts-nocheck
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store/store';
import i18n from './locales/composables/i18n';
import {VuetifyService} from '@/vuetify/services';
import moment from 'moment';
import Dialog from '@/errors/plugins/error-dialog';
import VueCompositionAPI, {createApp} from '@vue/composition-api';
import ErrorReportingService from './errors/plugins/error-reporting';
import LoadingFlagsPlugin from './loading/plugins/loading-flags';
import {IconPlugin} from '@/icons/plugins/icons';
import InertiaPlugin from '@/inertia/plugins/inertia';
import {useVersionCheckService} from '@/versioning/services/VersionCheckService';
import {inject} from '@/container';
import VuetifyPlugin from 'vuetify/lib';
import '@/sass/overrides.sass';
import {installDirective as installFormatInputDirective} from '@/common/directives/formatInputDirective';
import TextHighlightPlugin from '@/common/plugins/text-highlight';
import {PublicAssetPlugin} from '@/common/plugins/public-asset-plugin';
import {isDevelopment} from '@/environment';

Vue.config.productionTip = false;
Vue.config.devtools = isDevelopment();
// FIXME: not sure if I like having moment on Vue instances. Also, would make it $moment
Vue.prototype.moment = moment;

Vue.use(PublicAssetPlugin);
Vue.use(VuetifyPlugin);
Vue.use(VueCompositionAPI);

// Create the global app instance
const app = createApp({
  router,
  store,
  vuetify: inject(VuetifyService),
  i18n,
  render: (h) => h(App),
});

/*
 * Register plugins
 */
app.use(LoadingFlagsPlugin, {store});
app.use(Dialog);
app.use(InertiaPlugin);

app.use(ErrorReportingService);

app.use(IconPlugin);
app.use(TextHighlightPlugin);

/*
 * Directives
 */
installFormatInputDirective(app);

const root = app.mount('#app');

/*
 * Boot services
 */
useVersionCheckService().boot();

export {app, root};
